/**
 * 기술지원팀 월간보고서 (v2.113.0 · 2026-09-02)
 *
 * 이 문서는 포털에서 **쓰지 않는다** — 기술지원 포털이 만든 PDF 를 API 로 접수해
 * 그 사람 명의로 결재를 올린다. 그래서 여기에는 작성·수정 함수가 없다.
 * 목록·상세·결재(승인·반려·회수)는 지출결재와 **같은 통로**(expense-api)를 그대로 쓴다.
 */

/** 상세(GET /expense/docs/:id)의 tspReport 칸 — 다른 종류면 null */
export interface TspReportDetail {
  /** 기술지원 포털 문서번호 (예: SMS-MR-2026-0001) — 우리 문서번호와 별개 */
  extDocNo: string;
  /** 회차(판) — 그쪽에서 확정한 횟수. 1부터가 아닐 수 있고 연속도 아니다 */
  revision: number;
  /** 대상 월 'YYYY-MM' — 날짜가 아니라 그 달 전체 */
  periodYm: string;
  summary: string;
  clientId: number | null;
  clientName: string | null;
  /** 연결 시험 접수 — 결재선을 타지 않는 작성중 문서 */
  isTest: boolean;
  receivedAt: string | null;
}

/** '2026-07' → '2026년 7월'. 형식이 아니면 받은 값 그대로 */
export function periodText(ym: string): string {
  const m = /^(\d{4})-(\d{2})$/.exec(ym);
  return m ? `${m[1]}년 ${Number(m[2])}월` : ym;
}
